<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         placeholder="Nº Lote"
                                         :search-form="form">

          <t-input-code-label disable-name lot v-model="form.lotId"/>

          <t-input-search v-model="form.groupProductId"
                          :options="groupProductOptions"
                          label="Grupo de Produtos"
                          select/>

          <t-input-code-label model label="Modelo" v-model="form.modelId" />

        </t-content-header-search-default>
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">

          PX500 SP01-06092024

          <t-list-link-primary :label="item.lotCodeLabel" :userAuth="userAuth" :id="item.qualityParamId"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(logControl.createdDate)="{item}">
          {{ item.logControl.createdDate | datetime }}
        </template>

        <template #cell(actions)="{item}">
          <t-list-actions-default :form-path="currentPage.path" :id="item.qualityParamId"
                                  :userAuth="userAuth"/>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import groupProductService from "@/services/modules/product/GroupProduct.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'PolimixQualityParamByLot',
  data() {
    return {
      path: "custom/polimix/quality-param-by-lot", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Lote"},
        {key: "groupProduct", label: "Grupo"},
        {key: "model", label: "Modelo"},
        {key: "logControl.createdDate", label: "Data Processado"},
        {key: "actions", label: ""},
      ],
      form: {
        lotId:0,
        groupProductId: 0,
        modelId:0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupProductOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {
      //Remove busca por status do padrão, pois nesta tela não há status
      delete this.form.status
    },
    async mountedContinued() {

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
